import SplashElement from './SplashElement'

export default SplashElement
